import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from "vue";
import App from "@/App";
import router from "@/router"; // api: https://github.com/vuejs/vue-router
import store from "@/store"; // api: https://github.com/vuejs/vuex
import VueCookie from "vue-cookie"; // api: https://github.com/alfhen/vue-cookie
import "@/icons"; // api: http://www.iconfont.cn/
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/scss/index.scss";
import ElementUI from "element-ui";
import httpRequest from "@/utils/httpRequest"; // api: https://github.com/axios/axios
import { isAuth } from "@/utils";
import BaiduMap from "vue-baidu-map";

Vue.use(ElementUI);
Vue.use(BaiduMap, {
  ak: "miP4RMG1yZoROVRSqTPghvUaRb68iGUB"
});

// 引入全局图片自动压缩插件（必须在Vue.use(ElementUI)之后）
import "@/plugins/auto-compress.js";

Vue.use(VueCookie);
Vue.config.productionTip = false;

// 挂载全局
Vue.prototype.$http = httpRequest; // ajax请求方法
Vue.prototype.isAuth = isAuth; // 权限方法

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: { App }
});
